import React from "react";

const Main = props => {
  return <main id="main">{props.children}</main>;
};

export default Main;
